import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import UniqueCases from './components/UniqueCases';

const uniqueCases = (props, { t }) => (
  <Container>
    <UniqueCases {...props} />
  </Container>
);

uniqueCases.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(uniqueCases);
